export default __webpack_public_path__ + "static/media/icon_yoga.7db4ff61.svg";